import { GameActions } from '../../../State/Game/GameActions';
import { ContextType } from '../../../State/Game/IContext';
import ITask from '../../../Utility/Task/ITask';
import WorldSystem from '../WorldSystem';

export default class CreateShortcutTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<number> {
        system.state.dispatch(
            GameActions.setContext(ContextType.CREATE_SHORTCUT)
        );
    }
}
